// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"YY-z","subtitle":"ZY-z","wrapper":"_Y-z","leftArrow":"aZ-z","rightArrow":"bZ-z"};